var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.8,42.6c0,0.7-0.1,1.3,0,1.9c0.3,1.3,1.4,2,2.8,2.1c1.3,0,2.7,0,4,0c0.2,0,0.4,0,0.6,0.1 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.3,0-0.6,0.1-1,0.1c-12,0-24,0-36,0c-0.8,0-1.5-0.1-2.1-0.9c0.7,0,1.3,0,2,0c1,0,2-0.1,3,0 c2,0.1,3.6-1.2,3.2-3.5c0.4,0,0.7,0,1.1,0c0.9,0,1.8,0,2.7,0c0.2,0,0.4-0.2,0.5-0.3c0.2-0.3,0.3-0.7,0.5-1.1 c-0.1-0.1-0.2-0.2-0.3-0.3c-1.4-1.2-2.7-2.4-4.1-3.7c-0.2-0.2-0.3-0.4-0.3-0.7c-0.1-1.5-1.2-2.6-2.8-2.7c-0.9,0-1.9,0-2.8,0 c2.4-4.4,8.5-9.2,16.1-9.7c9.4-0.5,16.2,5.1,18.9,10.2c-0.6,0-1.2,0-1.8,0c-0.5,0-1,0-1.5,0c-1.3,0.1-2.2,0.9-2.6,2.1 c-0.1,0.3-0.2,0.6-0.5,0.7c-1.4,1.3-2.8,2.5-4.2,3.7c-0.3,0.3-0.3,0.4-0.2,0.8c0.2,0.7,0.6,0.9,1.3,0.8 C34.5,42.5,35.8,42.6,36.8,42.6z M28.8,38.2c2.2-2,4.4-3.9,6.6-5.9c-5.9-5.2-15.2-5-20.8,0c2.2,1.9,4.3,3.8,6.5,5.8 C23.7,36.9,26.2,36.9,28.8,38.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.9,3.1c5.4,0,9.8,4.4,9.7,9.8c0,5.4-4.4,9.8-9.8,9.7c-5.4,0-9.7-4.4-9.7-9.8C15.1,7.5,19.5,3.1,24.9,3.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.9,38.7c-0.2,0-0.4,0-0.6,0c-1.2,0-2.5,0-3.7,0c-0.9,0-1.5-0.5-1.6-1.2c-0.1-0.8,0.4-1.5,1.2-1.7 c0.2,0,0.3,0,0.5,0c2.1,0,4.2,0,6.3,0c0.9,0,1.6,0.4,1.8,1.2c0.3,0.8,0.5,1.6,0.6,2.4c0.2,1.5,0,3-0.5,4.4c-0.5,1.3-0.9,1.6-2.3,1.6 c-2,0-4,0-6,0c-0.9,0-1.4-0.4-1.6-1.1c-0.3-1,0.4-1.8,1.5-1.9c1.2,0,2.4,0,3.6,0c0.1,0,0.3,0,0.4,0c0.1,0,0.2-0.1,0.3-0.2 c-0.1-0.1-0.2-0.1-0.3-0.1c-1.3,0-2.6,0-4,0c-0.8,0-1.4-0.4-1.5-1.1c-0.3-1,0.4-1.9,1.4-1.9c1.3,0,2.6,0,4,0c0.2,0,0.3-0.1,0.5-0.1 C44,38.8,43.9,38.7,43.9,38.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,38.4c0.2,0,0.3,0.1,0.5,0.1c1.3,0,2.6,0,4,0c0.7,0,1.2,0.4,1.4,1.1c0.2,0.6,0,1.3-0.6,1.6 c-0.3,0.2-0.6,0.3-1,0.3c-1.2,0-2.4,0-3.6,0c-0.2,0-0.5,0.1-0.7,0.2c0.2,0.1,0.5,0.2,0.7,0.2c1.2,0,2.4,0,3.5,0c1,0,1.6,0.6,1.6,1.4 c0,0.9-0.7,1.5-1.6,1.5c-2.2,0-4.4,0-6.6,0c-0.7,0-1.1-0.3-1.4-0.9c-0.6-0.9-0.7-2-0.8-3c-0.1-1.3,0-2.7,0.4-4s0.9-1.7,2.3-1.7 c2,0,4.1,0,6.1,0c1,0,1.7,0.6,1.7,1.5s-0.7,1.5-1.7,1.5c-1.2,0-2.4,0-3.6,0c-0.2,0-0.4,0-0.6,0C6.1,38.2,6,38.3,6,38.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.7,33.8c0-1.2,0-2.5,0-3.7c0-0.7,0.8-1.3,1.7-1.3s1.6,0.5,1.7,1.3c0,0.2-0.1,0.4-0.2,0.6 c-0.6,0.8-1.2,1.6-1.7,2.5C5.8,33.8,5.4,34,4.7,33.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.3,34.3c-0.6,0.2-0.9,0-1.1-0.4c-0.6-1-1.3-2-2-3c-0.3-0.3-0.2-0.6,0-0.8c0.4-0.5,1.3-0.8,2-0.6 c0.7,0.2,1.2,0.8,1.2,1.5C45.4,32,45.3,33.2,45.3,34.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/driver.43f8402fcb68c4ec0660754a1b8b0433.svg";
export { ForwardRef as ReactComponent };